// extracted by mini-css-extract-plugin
module.exports = {"modalWidth":"Uploads_modalWidth__2-qHS"};